import React, { useState } from 'react';
import { useTypedIntl } from '@nxsys/hooks/useTypedIntl';
import AppInputSearch from '@nxsys/components/AppInputSearch';
import AppMenuFilter from '@nxsys/components/AppMenuFilter';
import TaxYearSelect from '@nxsys/components/TaxYearSelect';
import PSRFilterModal, { PSRFilterValues } from '../modals/PSRFilterModal';

export type PSRHeaderProps = {
  taxYear: number;
  filters: PSRFilterValues;
  searchTerm?: string;
  showStatus?: boolean;
  setTaxYear: (taxYear: number) => void;
  onApplyFilters: (filters: PSRFilterValues) => void;
  onChangeSearchTerm: (searchTerm: string) => void;
};

const PSRHeader: React.FC<PSRHeaderProps> = ({
  taxYear,
  filters,
  searchTerm = '',
  showStatus = false,
  setTaxYear,
  onApplyFilters,
  onChangeSearchTerm,
}) => {
  const { messages } = useTypedIntl();

  const [isOpenFilter, setIsOpenFilter] = useState(false);

  const toggleFilter = () => {
    setIsOpenFilter(!isOpenFilter);
  };

  const handleTaxYearChange = (taxYear?: number) => {
    setTaxYear(taxYear ?? 0);
  };

  const handleSearchChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    onChangeSearchTerm(e.target.value);
  };

  return (
    <div className="flex justify-between flex-wrap w-full gap-4">
      <div className="flex flex-wrap gap-4">
        <AppInputSearch
          placeholder={messages['common.search']}
          value={searchTerm}
          onChange={handleSearchChange}
        />
        <AppMenuFilter options={[]} onChange={() => {}} onClick={toggleFilter} />
      </div>
      <div className="flex flex-wrap gap-4 items-end">
        <TaxYearSelect
          placeholder={messages['rti.filters.selectTaxYear']}
          onFilter={(e) => handleTaxYearChange(e.taxYear as number)}
          initValue={taxYear}
        />
      </div>
      <PSRFilterModal
        isOpen={isOpenFilter}
        toggle={toggleFilter}
        values={filters}
        onFilter={onApplyFilters}
        showStatus={showStatus}
      />
    </div>
  );
};

export default PSRHeader;
